import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress'
import {styled, useTheme} from '@mui/material/styles'
import * as React from 'react'
interface Props {
  open: boolean
  step: number
  onClose: () => void
  totalSteps: number
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  children: React.ReactNode
  title?: string | React.ReactNode
  subTitle?: string | React.ReactNode
  topColor?: string
}

export default function ProgressDialog({
  open,
  step,
  onClose,
  totalSteps,
  maxWidth,
  children,
  title,
  subTitle,
  topColor,
}: Props) {
  const theme = useTheme()

  const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 6,
    borderRadius: 0,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
  }))

  return (
    <Dialog
      maxWidth={maxWidth ? maxWidth : 'md'}
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby='responsive-dialog-title'
    >
      <Box bgcolor={topColor ? topColor : 'inherit'}>
        {title && title}
        <BorderLinearProgress variant='determinate' value={(step / totalSteps) * 100} />
        {subTitle && subTitle}
      </Box>
      {children}
    </Dialog>
  )
}
